import {GenericResponse} from "@/lib/types/common.ts";
import {gql} from "@apollo/client";
import {SubscriptionPackTierWrapped} from "../../pages/billing/v2/subscriptions/Subscriptions";

export interface InstantSubscriptionData {
  braintreeToken: string;
  tiers: SubscriptionPackTierWrapped[];
}
export interface InstantSubscriptionQueryResponse {
  instantSubscriptionData: InstantSubscriptionData;
}

export const GQL_INSTANT_SUBSCRIPTION_QUERY = gql`
  query InstantSubscriptionQuery($billingPeriod: BillingPeriod!, $selectedTiers: [String!]!) {
    instantSubscriptionData(billingPeriod: $billingPeriod, selectedTiers: $selectedTiers) {
      braintreeToken
      tiers {
        packTitle
        tier_id
        pack_id
        price_monthly
        price_annual
        limits {
          limit_field
          limit_name
          value
          value_alt
        }
        is_current
      }
    }
  }
`;

export interface InstantSubscribeResponse {
  instantSubscribe: GenericResponse;
}
export const GQL_INSTANT_SUBSCRIBE_MUTATION = gql`
  mutation InstantSubscribe($data: InstantSubscribeInput!) {
    instantSubscribe(data: $data) {
      success
      errors
    }
  }
`;

export interface SessionHeartbeatResponse {
  sessionHeartbeat: GenericResponse;
}

export const GQL_SESSION_HEARTBEAT_QUERY = gql`
  query SessionHeartbeat {
    sessionHeartbeat {
      success
      errors
    }
  }
`;
